import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  const languages = [
    { code: 'it', label: 'IT', flag: '🇮🇹' },
    { code: 'de', label: 'DE', flag: '🇩🇪' },
    { code: 'fr', label: 'FR', flag: '🇫🇷' },
    { code: 'en', label: 'EN', flag: '🇬🇧' }
  ];

  return (
    <div className="flex items-center gap-1 bg-stone-800/50 rounded-full p-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
            language === lang.code
              ? 'bg-amber-600 text-white'
              : 'text-amber-100/70 hover:text-amber-100 hover:bg-stone-700/50'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
